import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { Icon } from "@components/icons"

const StyledProjectsGrid = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  a {
    position: relative;
    z-index: 1;
  }
`
const StyledProject = styled.li`
  position: relative;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(12, 1fr);
  align-items: center;

  @media (max-width: 768px) {
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover,
    &:focus {
      box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.7);
    }
  }

  &:not(:last-of-type) {
    margin-bottom: 100px;

    @media (max-width: 768px) {
      margin-bottom: 70px;
    }

    @media (max-width: 480px) {
      margin-bottom: 30px;
    }
  }

  &:nth-of-type(odd) {
    .project-content {
      grid-column: 7 / -1;
      text-align: right;

      @media (max-width: 1080px) {
        grid-column: 5 / -1;
      }
      @media (max-width: 768px) {
        grid-column: 1 / -1;
        padding: 40px 40px 30px;
        text-align: left;
      }
      @media (max-width: 480px) {
        padding: 25px 25px 20px;
      }
    }
    .project-tech-list {
      justify-content: flex-end;

      @media (max-width: 768px) {
        justify-content: flex-start;
      }

      li {
        margin: 0 0 5px 20px;

        @media (max-width: 768px) {
          margin: 0 10px 5px 0;
        }
      }
    }
    .project-links {
      justify-content: flex-end;
      margin-left: 0;
      margin-right: -10px;

      @media (max-width: 768px) {
        justify-content: flex-start;
        margin-left: -10px;
        margin-right: 0;
      }
    }
    .project-image {
      grid-column: 1 / 8;

      @media (max-width: 768px) {
        grid-column: 1 / -1;
      }
    }
  }

  .project-content {
    position: relative;
    grid-column: 1 / 7;
    grid-row: 1 / -1;

    @media (max-width: 1080px) {
      grid-column: 1 / 9;
    }

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      grid-column: 1 / -1;
      padding: 40px 40px 30px;
      z-index: 5;
    }

    @media (max-width: 480px) {
      padding: 30px 25px 20px;
    }
  }

  .project-title {
    color: #05d9e8;
    font-size: clamp(24px, 5vw, 28px);
    margin: 10px 0;
    font-weight: 400;

    @media (min-width: 768px) {
      margin: 0 0 20px;
    }

    @media (max-width: 768px) {
      a {
        position: static;

        &:before {
          content: "";
          display: block;
          position: absolute;
          z-index: 0;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .project-description {
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover,
    &:focus {
      box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.7);
    }
    position: relative;
    z-index: 2;
    padding: 25px;
    border-radius: 4px;
    background-color: #01012b;
    font-size: 16px;

    @media (max-width: 768px) {
      padding: 20px 0;
      background-color: transparent;
      box-shadow: none;

      &:hover {
        box-shadow: none;
      }
    }

    a {
      display: inline-block;
      text-decoration: none;
      text-decoration-skip-ink: auto;
      position: relative;
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
      color: #6afffe;
      &:hover,
      &:focus,
      &:active {
        color: #6afffe;
        outline: 0;
        &:after {
          width: 100%;
        }
        & > * {
          color: #6afffe;
          transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
      }
      &:after {
        content: "";
        display: block;
        width: 0;
        height: 1px;
        position: relative;
        bottom: 0.37em;
        background-color: #6afffe;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        opacity: 0.5;
      }
    }
  }

  .project-tech-list {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
    margin: 25px 0 10px;
    padding: 0;
    list-style: none;

    li {
      margin: 0 20px 5px 0;
      color: #d1f7ff;
      font-size: 12px;
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      margin: 10px 0;

      li {
        margin: 0 10px 5px 0;
        color: #a8b2d1;
      }
    }
  }

  .project-links {
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 10px;
    margin-left: -10px;
    color: #ccd6f6;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;

      &.external {
        svg {
          width: 20px;
          height: 20px;
          margin-top: -8px;
        }
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .project-image {
    background-color: #005678;
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    grid-column: 6 / -1;
    grid-row: 1 / -1;
    position: relative;
    z-index: 1;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover,
    &:focus {
      box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.7);
    }

    @media (max-width: 768px) {
      grid-column: 1 / -1;
      height: 100%;
      opacity: 0.25;
    }

    a {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      vertical-align: middle;

      &:hover,
      &:focus {
        background: transparent;
        outline: 0;

        &:before,
        .img {
          background: transparent;
          filter: none;
        }
      }

      &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        background-color: #005678;
        mix-blend-mode: screen;
      }
    }

    .img {
      border-radius: 4px;
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1) brightness(90%);

      @media (max-width: 768px) {
        object-fit: cover;
        width: auto;
        height: 100%;
        filter: grayscale(100%) contrast(1) brightness(80%);
      }
    }
  }
`
const Project = ({}) => {
  return (
    <StyledProjectsGrid>
      <StyledProject>
        <div className="project-content">
          <div>
            <h4 className="">SpaceX</h4>
            <div className="project-description">
              In this project the goal was to create a microsite for SpaceX
              to raise awareness about space program activity around the world.
              The site appeal to a specific target audience and information
              about live feeds of launches and etc.
            </div>
            <ul className="project-tech-list">
              <li>HTML</li>
              <li>CSS</li>
              <li>JAVASCRIPT</li>
              <li>BOOTSTRAP</li>
            </ul>
            <div className="project-links">
              <a
                href="https://github.com/benoah/updatedV1spaceX"
                aria-label="GitHub Link"
              >
                <Icon name="GitHub" />
              </a>
              <a href="https://soacex.netlify.app/" aria-label="GitHub Link">
                <Icon name="IconBookmark" />
              </a>
            </div>
          </div>
        </div>
        <div className="project-image">
          <a href="https://soacex.netlify.app/">
            <StaticImage
              placeholder="blurred"
              className="img"
              src="../../assets/images/spacex.png"
              width={700}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Headshot"
            />
          </a>
        </div>
      </StyledProject>
      <StyledProject>
        <div className="project-content">
          <div>
            <h4 className="project-overline" href="/">
              Hall of fames kick´s store
            </h4>
            <div className="project-description">
              E-commerce website, including frontend with home, product list,
              product detail and cart pages. When admin user is logged in, the
              user is able to create, update and delete products. The website is
              responsive on all devices. The username is admin@gmail.com and the
              Password is Pass1234
            </div>
            <ul className="project-tech-list">
              <li>HTML</li>
              <li>Javascript</li>
              <li>Material Ui</li>
              <li>Strapi</li>
            </ul>
            <div className="project-links">
              <a
                href="https://github.com/benoah/sneakershop"
                aria-label="GitHub Link"
              >
                <Icon name="GitHub" />
              </a>
              <a
                href="https://angry-jepsen-a4ad24.netlify.app/shop.html"
                aria-label="GitHub Link"
              >
                <Icon name="IconBookmark" />
              </a>
            </div>
          </div>
        </div>
        <div className="project-image">
          <a href="https://angry-jepsen-a4ad24.netlify.app/shop.html">
            <StaticImage
              className="img"
              src="../../assets/images/kicks.png"
              width={700}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Headshot"
            />
          </a>
        </div>
      </StyledProject>
      <StyledProject>
        <div className="project-content">
          <div>
            <h4 className="" href="/">
              Movie App
            </h4>
            <div className="project-description">
              In this procjet the the goal was to clone Netflix UI, and also
              getting movies from api and show the movie trailer.
            </div>
            <ul className="project-tech-list">
              <li>React</li>
              <li>React-youtube</li>
              <li>Material UI</li>
              <li>BEM</li>
            </ul>
            <div className="project-links">
              <a
                href="https://github.com/benoah/updatedV1spaceX"
                aria-label="GitHub Link"
              >
                <Icon name="GitHub" />
              </a>
              <a
                href="https://wonderful-sinoussi-ce697d.netlify.app/"
                aria-label="GitHub Link"
              >
                <Icon name="IconBookmark" />
              </a>
            </div>
          </div>
        </div>
        <div className="project-image">
          <a href="https://wonderful-sinoussi-ce697d.netlify.app/">
            <StaticImage
              className="img"
              src="../../assets/images/nflex.png"
              width={700}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Headshot"
            />
          </a>
        </div>
      </StyledProject>
      <StyledProject>
        <div className="project-content">
          <div>
            <h4 className="" href="/">
              Covid Tracker{" "}
            </h4>
            <div className="project-description">
              In this project the the goal was to build a Covid tracker.
            </div>
            <ul className="project-tech-list">
              <li>React</li>
              <li>@material-ui/core</li>
              <li>Chart.js</li>
              <li>numeral</li>
            </ul>
            <div className="project-links">
              <a
                href="https://github.com/benoah/covid-19-tracker"
                aria-label="GitHub Link"
              >
                <Icon name="GitHub" />
              </a>
              <a
                href="https://naughty-tesla-7cab4f.netlify.app/"
                aria-label="GitHub Link"
              >
                <Icon name="IconBookmark" />
              </a>
            </div>
          </div>
        </div>
        <div className="project-image">
          <a href="/">
            <StaticImage
              className="img"
              src="../../assets/images/covid.png"
              width={700}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Headshot"
            />
          </a>
        </div>
      </StyledProject>
    </StyledProjectsGrid>
  )
}

export default Project
